module.exports = __webpack_public_path__ + "static/mobile-i-phone-vertical-8dc530d609cd454f9547b9d3a0f6a2c4.png";